import { Component, OnDestroy, Optional, Inject, Input } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ExchangeAgreementConfirmLaterDialogComponent } from '../ExchangeAgreementConfirmlaterDialog/exchange-agreement-confirmlater-dialog.component';
import { Subscription } from 'rxjs';
import { TradingService, TradingEntitlements } from '@pershing/trading-common';

@Component({
    selector: 'exchange-agreement-overview',
    templateUrl: './exchange-agreement-overview.component.html'
})
export class ExchangeAgreementOverviewComponent implements OnDestroy {
    @Input() platform: string;
    @Input() public tradingEntitlements: TradingEntitlements = null;

    subs: Subscription;
    frompage: any;
    deviceType: string = 'desktop';
    constructor(
        private tradingService: TradingService,
        private dialog: MatDialog, @Optional() @Inject('AppSettings') appSettings: any) {
            if (!!appSettings.deviceType) {
                this.deviceType = appSettings.deviceType;
            }
    }

    showCancelDialog(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.minWidth = '250px';
        dialogConfig.disableClose = true;
        const exchangeAgreementConfirmLaterDialogClosing = this.dialog.open(ExchangeAgreementConfirmLaterDialogComponent, dialogConfig);

        exchangeAgreementConfirmLaterDialogClosing.afterClosed().subscribe(result => {
            console.log(result);
            // fire the entitlement call to refresh the entitlement data in the client memory
            this.tradingService.getEntitlements(this.platform);
        });

    }
    nonProfDisclosure() {
        console.log('from overview');
        this.tradingService.setExchangeAgreementDialogState('nonProfDisclosure');
    }
    ngOnDestroy(): void {
        // this.dialog.close();
        if (this.subs) {
            this.subs.unsubscribe();
        }
    }

}
